import { KIT } from "@/constants/testIds";

export const EmptyState = ({ icon: Icon, title, description, children }) => (
  <div data-testid={KIT.emptyState} className="ps-card px-6 py-16 text-center sm:py-20">
    {Icon && (
      <span className="mx-auto mb-5 grid h-16 w-16 place-items-center rounded-full bg-secondary text-brand-tealSoft">
        <Icon className="h-6 w-6" />
      </span>
    )}
    <h3 className="font-display text-2xl font-semibold text-brand-teal">{title}</h3>
    {description && (
      <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-muted-foreground">{description}</p>
    )}
    {children && <div className="mt-7 flex justify-center">{children}</div>}
  </div>
);
